const getIsUserPaypalSubscriptionActive = (userPaypalSubscription) => userPaypalSubscription && userPaypalSubscription.status === 'ACTIVE';

export { getIsUserPaypalSubscriptionActive };
